import { render, staticRenderFns } from "./GroupAlertAllowBehaviorEditor.vue?vue&type=template&id=4cc5f366&scoped=true&"
import script from "./GroupAlertAllowBehaviorEditor.vue?vue&type=script&lang=ts&"
export * from "./GroupAlertAllowBehaviorEditor.vue?vue&type=script&lang=ts&"
import style0 from "./GroupAlertAllowBehaviorEditor.vue?vue&type=style&index=0&id=4cc5f366&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4cc5f366",
  null
  
)

export default component.exports